
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Status = () => {
  return (
    <SettingsMetaData propertyName={"status_supplier"} viewPropertyName={"Status"} />
  );
};
export default Status;
